import styled from 'styled-components'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Typography } from '@healingpaper/cell'

import { getDownloadLink, postAmplitude } from '@/core/lib'
import { useLocales } from '@/shared/hooks/useLocales'
import { Locales } from '@/utils/language'

export interface Props {
  closePopup: () => void
}
const AppDownloadModal = ({ closePopup }: Props): JSX.Element => {
  const { t } = useTranslation()
  const { locale } = useLocales()

  useEffect(() => {
    postAmplitude('view_download_modal_in_home')
  }, [])

  const INFO: Record<Locales, { title?: string; image?: string; button?: string; url?: string }> = {
    [Locales.KO_KR]: {
      image: '/images/app_download_kr.webp',
    },
    [Locales.JA_JP]: {
      image: '/images/app_download_jp.webp',
    },
    [Locales.EN_US]: {
      image: '/images/app_download_en.webp',
    },
    [Locales.TH_TH]: {
      title: t('modal.appDownload.title'),
      image: '/images/app_download_en.webp',
    },
    [Locales.ZH_HANS_CN]: {},
    [Locales.ZH_HANT_TW]: {},
  }

  return (
    <StyledContainer className="px-6">
      <StyledTitle>
        <Typography type="title1" color="white">
          {INFO[locale].title || t('modal.appDownload.title')}
        </Typography>
      </StyledTitle>
      <StyledImage src={INFO[locale].image} alt="App Download" />
      <StyledButton
        fullWidth
        onClick={() => {
          postAmplitude('click_download', {
            button_position: 'download-modal',
          })
          closePopup()
          const url = INFO[locale].url || getDownloadLink()
          window.open(url, '_blank')
        }}
      >
        <Typography type="title1" color="white">
          {INFO[locale].button || t('modal.appDownload.button')}
        </Typography>
      </StyledButton>
      <StyledCloseButton
        onClick={() => {
          postAmplitude('click_cancel_in_download_modal')
          closePopup()
        }}
      >
        <Typography type="description1" color="white">
          {t('modal.appDownload.cancel')}
        </Typography>
      </StyledCloseButton>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  max-width: 374px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const StyledTitle = styled.div`
  h1 {
    text-align: center;
  }
`

const StyledImage = styled.img`
  width: 100%;
  max-width: 80vw;
  height: auto;
`

const StyledButton = styled(Button)<{ disabled?: boolean }>`
  flex: 1;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : '')};
  border-radius: 30px;
  padding: 16px 0;

  font-weight: 700;
  font-size: 20px;

  ${({ disabled }) =>
    !disabled &&
    `
      background: linear-gradient(to right, #ff540f, #ff9442);
      color: white;
    `}
`

const StyledCloseButton = styled.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid white;
  p {
    line-height: 20px;
  }
`

export default AppDownloadModal
